const schema = {
    title: {
        type: 'text',
        label: 'News Title',
        placeholder: 'Enter News Title',
        required: true,
        info: true,
        character_count: 250,
        tooltip: 'Title will be display on top',
    },
    date: {
        type: 'date',
        label: 'Date',
        placeholder: 'Enter Date',
        required: true,
        info: true,
        character_count: 0,
        wrapper_class: 'col-6'
    },
    color: {
        type: 'color',
        label: 'Ribbon Colour',
        placeholder: 'Choose Colour',
        required: true,
        info: true,
        character_count: 0,
        wrapper_class: 'col-3'
    },
    featured: {
        type: 'toggle',
        label: 'Featured',
        placeholder: 'Select Featured',
        required: false,
        info: true,
        character_count: 0,
        wrapper_class: 'col-3'
    },
    slug: {
        type: 'text',
        label: 'Path',
        placeholder: 'Enter Slug',
        required: true,
        info: true,
        character_count: 50
    },
    news_ticker: {
        type: 'text',
        label: 'News Banner',
        placeholder: 'Enter News Ticker',
        required: true,
        info: true,
        character_count: 250
    },
    upload_options: {
        type: 'select',
        label: 'Upload Options',
        placeholder: 'Select Upload Options',
        options: [],
        required: false,
        info: true,
        character_count: 0,
        wrapper_class: 'col-6'
    },
    video_url: {
        type: 'text',
        label: 'Video URL',
        placeholder: '',
        required: false,
        info: true,
        character_count: 0,
        wrapper_class: 'col-6'
    },
    desc: {
        type: 'ckeditor',
        label: 'Description',
        required: true,
        info: false,
        character_count: 2000
    }
};

const topics = [
    {
        id: 1,
        title: 'Diabetes',
        slug: 'diabetes',
        news_ticker: 'Diabetes Ticker',
        desc: 'Diabetes Desc'
        
    },
    {
        id: 2,
        title: 'Covid-19',
        slug: 'covid_19',
        news_ticker: 'Covid Ticker',
        desc: 'Covid Desc'
    },
    {
        id: 3,
        title: 'Total Triage System',
        slug: 'total_triage_system',
        news_ticker: 'Total Triage System Ticker',
        desc: 'Total Triage System Desc'
    },
    {
        id: 4,
        title: 'How to keep your child safe',
        slug: 'child_safety',
        news_ticker: 'Child Safety Ticker',
        desc: 'Child Safety Desc'
    }
];  

const massUpdates = [
    {
        id: 1,
        title: 'Diabetes MU',
        slug: 'diabetes',
        news_ticker: 'Diabetes Ticker',
        desc: 'Diabetes Desc'
        
    },
    {
        id: 2,
        title: 'Covid-19 MU',
        slug: 'covid_19',
        news_ticker: 'Covid Ticker',
        desc: 'Covid Desc'
    },
    {
        id: 3,
        title: 'Total Triage System MU',
        slug: 'total_triage_system',
        news_ticker: 'Total Triage System Ticker',
        desc: 'Total Triage System Desc'
    },
    {
        id: 4,
        title: 'How to keep your child safe MU',
        slug: 'child_safety',
        news_ticker: 'Child Safety Ticker',
        desc: 'Child Safety Desc'
    }
];  
const doctorNames = [
    {
        id: 1,
        name: 'Dr. Frank Vickery'
    },
    {
        id: 2,
        name: 'Dr. Robert Winter'
    },
    {
        id: 3,
        name: 'Dr. Crystal Elliott'
    },
    {
        id: 4,
        name: 'Dr. Kristen Steele'
    }
];  

const chatData = [
    {
        id: 1,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Frank Vickery',
        message: 'Hey! there I\'m available',
        time: '04    min',
        status: 'online'
    },
    {
        id: 2,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Robert Winter',
        message: 'I\'ve finished it! See you so',
        time: '09 min',
        status: 'away'
    },
    {
        id: 3,
        name: 'Crystal Elliott',
        message: 'This theme is awesome!',
        time: '21 min',
        status: 'online'
    },
    {
        id: 4,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Kristen Steele',
        message: 'Nice to meet you',
        time: '1 hr',
    },
    {
        id: 5,
        name: 'Mitchel Givens',
        message: 'Hey! there I\'m available',
        time: '3 hrs',
        status: 'away'
    },
    {
        id: 6,
        image: require('@/assets/images/users/avatar-6.jpg'),
        name: 'Stephen Hadley',
        message: 'I\'ve finished it! See you so',
        time: '5 hrs',
        status: 'online'
    },
    {
        id: 7,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Tracy Penley',
        message: 'This theme is awesome!',
        time: '24/03',
        status: 'online'
    },
];  

const chatMessagesData = [
    {
        name: 'Frank Vickery',
        image: require('@/assets/images/users/avatar-2.jpg'),
        message: 'Hello!',
        time: '10:00'
    },
    {
        align: 'right',
        name: 'Henry Wells',
        message: 'Hi, How are you? What about our next meeting?',
        time: '10:02'
    },
    {
        name: 'Frank Vickery',
        image: require('@/assets/images/users/avatar-2.jpg'),
        message: 'Yeah everything is fine',
        time: '10:06'
    },
    {
        name: 'Frank Vickery',
        image: require('@/assets/images/users/avatar-2.jpg'),
        message: '& Next meeting tomorrow 10.00AM',
        time: '10:06'
    },
    {
        align: 'right',
        name: 'Henry Wells',
        message: 'Wow that\'s great',
        time: '10:07'
    }
];

export { schema, topics, massUpdates, doctorNames, chatData, chatMessagesData };